import ComingSoon from "../../Components/ComingSoon";


const RecapturePage = () => {
  return (
    <ComingSoon showMinnect={true} />
  )
};

export default RecapturePage;
